import React from 'react';
import { Box, CircularProgress, ListItem, ListItemText, palette, } from '@kareo/design-system';
import { StyledNavList } from '../../utils/styledFacesheet';
import useChartNavbarLinks from '../../hooks/useChartNavbarLinks';
var FacesheetNavBar = function (_a) {
    var links = _a.links, patientId = _a.patientId;
    var _b = useChartNavbarLinks(links, patientId), loading = _b.loading, navbarLinks = _b.navbarLinks;
    var linksToDisplay = links || navbarLinks;
    return (React.createElement(Box, { component: "div", width: "100%", minWidth: "10rem", bgcolor: palette.background.paper, border: 1, borderColor: "background.default", marginTop: "-1px" },
        React.createElement(StyledNavList, { "aria-label": "patient navbar list" }, loading ? (React.createElement(Box, null,
            React.createElement(CircularProgress, null))) : (linksToDisplay &&
            linksToDisplay.map(function (link, index) { return (React.createElement(ListItem, { component: "a", key: link.linkName, href: link.url.replace('{patientId}', String(patientId)) },
                React.createElement(ListItemText, { primary: link.displayName }))); })))));
};
export default FacesheetNavBar;
